/* eslint-disable react/jsx-max-props-per-line */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';

import If from 'components/UI/If/If';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '80%',
  bgcolor: 'background.paper',
  borderRadius: '0.3rem',
  maxHeight: '80%',
  overflow: 'auto',
};

const MuiModal = ({ children, closeMethod, disabledPrimaryButton, onClickAway, primaryButtonMethod,
  primaryButtonText, secondaryButtonMethod, secondaryButtonText, title, visible }) => {

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  useEffect(() => {
    if (visible) {
      handleOpen();
    } else {
      handleClose();
    }
  }, [handleClose, handleOpen, visible]);

  return (
    <div>
      <Modal
        aria-describedby="modal-modal-description"
        aria-labelledby="modal-modal-title"
        onClose={onClickAway}
        open={open}
      >
        <Box sx={style}>
          <div className="modal-header">
            <h5 className="modal-title">{title}</h5>
            <button aria-label="Fechar" className="close" data-dismiss="modal" type="button">
              <span aria-hidden="true" onClick={closeMethod}>&times;</span>
            </button>
          </div>

          <div className="modal-body">
            {children}
          </div>

          <footer style={{ marginBottom: '1rem', marginRight: '1rem' }}>
            <div className="d-flex justify-content-end">
              <If test={secondaryButtonText}>
                <button className="btn btn-secondary" data-dismiss="modal" onClick={secondaryButtonMethod} type="button">{secondaryButtonText}</button>
              </If>
              <button className="btn btn-primary ml-5" disabled={disabledPrimaryButton} onClick={primaryButtonMethod} type="button">{primaryButtonText}</button>
            </div>
          </footer>
        </Box>

      </Modal>
    </div>
  )
}

MuiModal.propTypes = {
  children: PropTypes.element,
  closeMethod: PropTypes.func.isRequired,
  disabledPrimaryButton: PropTypes.bool,
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onClickAway: PropTypes.func,
  primaryButtonMethod: PropTypes.func.isRequired,
  primaryButtonText: PropTypes.string.isRequired,
  secondaryButtonMethod: PropTypes.func,
  secondaryButtonText: PropTypes.string,
  title: PropTypes.string.isRequired,
  visible: PropTypes.bool.isRequired,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

MuiModal.defaultProps = {
  children: null,
  disabledPrimaryButton: false,
  height: 0,
  onClickAway: () => {},
}

export default MuiModal;
